import { Button, ButtonProps, IconArrowDown } from '@cmpsr/components';

export default function LoadMoreButton(props: ButtonProps) {
  return (
    <Button variant="link-primary" trailingIcon={<IconArrowDown />} size="m" {...props}>
      See All
    </Button>
  );
}
